import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field, getIn } from 'formik';
import { useTranslation } from '../../../../src/i18n';
import FormikAutocompleteSelect from '../../../../components/Fields/FormikAutocompleteSelect';
import FormikCheckbox from '../../../../components/Fields/CheckboxField/FormikCheckbox';
import { TP } from '../../../../constants/consts';
import NoOptionsBox from '../../../../components/NoOptionsBox';
import Button from '../../../../components/Button';
import AddNewCompanyModal from '../../../../components/AddNewCompanyModal';
import { getOption } from '../../../../utils/common';

const MainCompanyFields = ({
  values,
  classes,
  setFieldValue,
  setValues,
  companyField,
  isCompanyUnknownField,
  companiesList,
  getCompaniesList,
  production,
  resetOptions,
  loadingCompanyFieldName,
  isCompanyEdit,
}) => {
  const { t } = useTranslation();

  const [companyStartSearching, setCompanySearching] = React.useState(false);
  const [newCompanyName, setNewCompanyName] = React.useState(null);
  const [isAddNewCompanyModalOpened, setAddNewCompanyModalOpened] = React.useState(false);

  React.useEffect(() => {
    setCompanySearching(false);
  }, [companiesList]);

  return (
    <>
      <Field
        className={classes.addFields}
        name={companyField.name}
        component={FormikAutocompleteSelect}
        instanceId={companyField.name}
        options={companiesList}
        label={t(companyField.label)}
        onInputTextChange={v => {
          setCompanySearching(true);
          getCompaniesList(companyField.name, v);
          setNewCompanyName({ fieldName: companyField.name, name: v });
        }}
        startAggregations={companyStartSearching}
        onChange={resetOptions}
        isLoading={loadingCompanyFieldName === companyField.name}
        onFocus={() => {
          setCompanySearching(true);
          getCompaniesList(companyField.name, '');
        }}
        customComponents={{
          NoOptionsMessage: () => (
            <NoOptionsBox
              buttonText={`${TP}.FN_ADD_NEW_COMPANY`}
              openFormFunc={() => setAddNewCompanyModalOpened(true)}
              t={t}
            />
          ),
        }}
        staticOption={
          <Button onClick={() => setAddNewCompanyModalOpened(true)}>{t(`${TP}.FN_ADD_NEW_COMPANY`)}</Button>
        }
        isDisabled={Boolean(
          isCompanyEdit || (production.published_at && production.company) || getIn(values, isCompanyUnknownField.name),
        )}
        isClearable
      />
      {!(isCompanyEdit || (production.published_at && production.company)) && (
        <Field
          classNameRoot={classes.companyCheckbox}
          name={isCompanyUnknownField.name}
          label={t(isCompanyUnknownField.label)}
          component={FormikCheckbox}
          onChange={v => {
            if (v) {
              setValues({ ...values, [companyField.name]: null, [isCompanyUnknownField.name]: v });
            } else {
              setFieldValue(isCompanyUnknownField.name, v);
            }
          }}
          isDisabled={production.published_at && production.company}
          preventDefaultOnChange
        />
      )}
      {isAddNewCompanyModalOpened && (
        <AddNewCompanyModal
          onClose={createdCompany => {
            if (createdCompany?.id) {
              setFieldValue(companyField.name, getOption(createdCompany));
            }
            setAddNewCompanyModalOpened(false);
            setNewCompanyName(null);
          }}
          companyName={newCompanyName?.name || ''}
        />
      )}
    </>
  );
};

MainCompanyFields.propTypes = {
  values: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  companyField: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isCompanyEdit: PropTypes.bool.isRequired,
};

export default memo(MainCompanyFields);
